import { useMutation } from '@apollo/client';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import React from 'react';
import { UPDATE_APPOINTMENT_ASSIGNMENT } from 'services/graphql/mutations/appointmentAssignments';
import { AssignmentStatus } from 'types/appointmentAssignments';
import { GeneralFunction } from 'types/common';
import { defaultNotification } from 'utils';

import { INotaryAppointments } from '../types';

const ActionButtons: React.FC<{ closeModal?: GeneralFunction; notaryAppointment: INotaryAppointments }> = ({
  closeModal,
  notaryAppointment,
}) => {
  const [updateAssignment] = useMutation(UPDATE_APPOINTMENT_ASSIGNMENT);
  const mutateAssignment = async (assignmentStatus: AssignmentStatus) => {
    try {
      await updateAssignment({
        variables: {
          filter: {
            id: notaryAppointment.assignmentId,
          },
          updatedDoc: {
            status: assignmentStatus,
          },
        },
      });
      defaultNotification({ success: 'Appointment request changed successfully!' });
      closeModal?.();
    } catch (err) {
      defaultNotification({ failure: 'Something went wrong! Please try again!' });
    }
  };

  const acceptAppointment = () => {
    mutateAssignment(AssignmentStatus.APPROVED);
  };

  const rejectAppointment = () => {
    mutateAssignment(AssignmentStatus.REJECTED);
  };

  const onRejectAppointment = () => {
    rejectAppointment();
  };
  const onAcceptAppointment = () => {
    acceptAppointment();
  };
  return (
    <div className='gx-d-flex appointment-button-container'>
      <div className='reject-button gx-w-50'>
        <ButtonWithSpinner
          onClick={onRejectAppointment}
          buttonType='default'
          color='white'
          rounded={false}
          bgColor='#EC4749'
          border='none'
          width='100%'>
          Reject Appointment
        </ButtonWithSpinner>
      </div>
      <div className='accept-button gx-w-50'>
        <ButtonWithSpinner
          onClick={onAcceptAppointment}
          buttonType='default'
          color='white'
          rounded={false}
          bgColor='#11A278'
          border='none'
          width='100%'>
          Accept Appointment
        </ButtonWithSpinner>
      </div>
    </div>
  );
};

export default ActionButtons;
